import { render, staticRenderFns } from "./HTMLView.vue?vue&type=template&id=afbd6b26&scoped=true"
import script from "./HTMLView.vue?vue&type=script&lang=js"
export * from "./HTMLView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbd6b26",
  null
  
)

export default component.exports